/* The circular header portrait opens a zoom, without changing the current page.
   Only this avatar button triggers the dialog. The name link is untouched. */
(() => {
  const init = () => {
    const trigger = document.querySelector('[data-sf-profile-trigger]');
    const dialog = document.querySelector('[data-sf-profile-egg]');
    if (!trigger || !dialog || typeof dialog.showModal !== 'function' || trigger.dataset.sfPortraitZoomReady) return;
    trigger.dataset.sfPortraitZoomReady = 'true';

    trigger.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (!dialog.open) dialog.showModal();
    });

    dialog.querySelector('[data-sf-profile-close]')?.addEventListener('click', () => {
      if (dialog.open) dialog.close();
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();